import React from 'react'
import PropTypes from 'prop-types'

import { InnerHtml } from '../global'

/**
 * A component for various types of paragraphs in post flex content
 *
 * @param {string} props.src- Image source
 * @param {string} props.alt - Image alt text
 * @param {string} props.caption - Optional image caption
 * @param {string} props.description - Optional image description
 * @param {boolean} props.fullWidth - Adds fullwidth class
 * @param {string} props.extraClasses - Adds additional classNames
 * @param {any} props.rest - Used to add e.g. inline style or key
 *
 * @returns {JSX.Element} Renders paragraph with correct layout & content
 */

const PostImageBlock = ({
  src,
  alt,
  caption,
  description,
  fullWidth,
  extraClasses = '',
  ...rest
}) => {
  const size = fullWidth ? 'full' : 'container'

  return (
    <div
      className={`post-paragraph__img-block ${size} ${extraClasses}`}
      {...rest}
    >
      <img className={`image__${size}`} alt={alt} src={src} />
      <div className="image-details">
        {/* 
        ** Empty image caption seems to be populated w/ image description
        ** Temp comment out as it isn't being used by the writers
        */}
        {/* {caption && <InnerHtml className="image-caption" content={caption} />} */}
        {description && (
          <InnerHtml className="image-caption" content={description} />
        )}
      </div>
    </div>
  )
}

// This prob can replace the param comment block
PostImageBlock.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  caption: PropTypes.string,
  description: PropTypes.string,
  fullWidth: PropTypes.bool,
  extraClasses: PropTypes.string,
  rest: PropTypes.any,
}

export default PostImageBlock
